import numeral from 'numeral';

exports.formatNumbers = (num, format) => {
    if (format) {
        return numeral(num).format(format);
    }

    if (num < 1000) {
        return numeral(num).format('0');
    } else if (num >= 1000 && num < 1000000000) {
        return numeral(num).format('0.0,a');
    }

    return numeral(num).format('0a');
};

exports.formatNumber = value => exports.formatNumbers(value, '0,0');

exports.formatPercentage = (value, { format = '0.00' } = {}) => `${exports.formatNumbers(value * 100, format)} %`;

exports.formatPrice = (value, { format = '$ 0,0.00' } = {}) => exports.formatNumbers(value, format);
exports.formatPriceWithoutSpace = value => exports.formatNumbers(value, '$0,0.00');

exports.formatByType = (value, type) => {
    switch (type) {
    case 'number':
        return exports.formatNumber(value);
    case 'floatX2':
        return exports.formatNumbers(value, '0[.][00]');
    case 'percentage':
        return exports.formatPercentage(value);
    case 'percentageNoPrecision':
        return exports.formatPercentage(value, { format: '0' });
    case 'price':
        return exports.formatPrice(value);
    case 'priceNoPrecision':
        return exports.formatPrice(value, { format: '$ 0,0' });
    case 'priceWithoutSpace':
        return exports.formatPriceWithoutSpace(value);
    default:
        return value;
    }
};



// WEBPACK FOOTER //
// ./src/helpers/formatNumbers.js